import { cloneDeep } from "lodash";
import { ADD_CONNECTION_VALUE_SUCCESS, DEACTIVATE_CONNECTION_VALUE_SUCCESS, GET_CONNECTION_VALUES_ERROR, GET_CONNECTION_VALUES_STARTING, GET_CONNECTION_VALUES_SUCCESS, UPDATE_CONNECTION_VALUE_SUCCESS } from "../../../constants/actionTypes";
import initialState from "../../../store/initialState";

export default function connectionValuesReducer(state = initialState.connectionValues, action) {

    const sortByOrder = (newState) => { }  

    switch (action.type) {
        case GET_CONNECTION_VALUES_STARTING: {
            const newState = cloneDeep(state);
            newState.loading = true;
            newState.loaded = false;
            return newState;
        }

        case GET_CONNECTION_VALUES_SUCCESS: {
            const newState = cloneDeep(state);
            const ids = [];
            action.data.connectionValueData.forEach((connectionValue) => {
                const connectionValueId = connectionValue.id;
                ids.push(connectionValueId);
                newState.map[connectionValueId] = connectionValue;
            });
            newState.ids = ids;
            newState.loading = false;
            newState.loaded = true;
            return newState;
        }

        case GET_CONNECTION_VALUES_ERROR: {
            const newState = cloneDeep(state);
            newState.loading = false;
            newState.loaded = true;
            return newState;
        }

        case ADD_CONNECTION_VALUE_SUCCESS: {
            const { connectionValueData } = action.data;
            const newState = cloneDeep(state);
            const connectionId = connectionValueData.id;

            newState.map[connectionId] = connectionValueData;
            newState.ids.push(connectionId);

            sortByOrder(newState);

            return newState;
        }

        case UPDATE_CONNECTION_VALUE_SUCCESS: {
            const newState = cloneDeep(state);
            const { connectionValueData } = action.data;
            const connectionId = connectionValueData.id;
            newState.map[connectionId] = connectionValueData;

            sortByOrder(newState);
            return newState;
        }

        case DEACTIVATE_CONNECTION_VALUE_SUCCESS: {
            const newState = cloneDeep(state);
            console.log("action",action)
            const { connectionValueId } = action;
            newState.inactiveIds.push(connectionValueId);

            newState.ids = newState.ids.filter((cvId)=>{
                return connectionValueId !== cvId;
            });

            if(newState.map[connectionValueId]) {
                newState.map[connectionValueId].isActive = 0;
            }

            sortByOrder(newState);
            return newState;
        }

        default: {
            return state;
        }
    }
}